import { Injectable } from '@angular/core';
import { ApiService, IApiOption } from '@red/api';
import { PaginationAdapter } from '@red/data-access';
import { CommissionMatrixCreateDto, CommissionMatrixUpdateDto } from '@shared/data-access/dto';
import { IKeyAppointment } from '@shared/data-access/interfaces';
import { CommissionMatrixModel } from '@shared/data-access/models';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CommissionMatrixApiService {
  static ROOT_POINT = 'transaction/commission-matrices';

  constructor(private apiService: ApiService) {}

  create(data: CommissionMatrixCreateDto): Observable<CommissionMatrixModel> {
    return this.apiService
      .post(`${CommissionMatrixApiService.ROOT_POINT}`, data)
      .pipe(map((res: IKeyAppointment) => CommissionMatrixModel.fromJson(res) as CommissionMatrixModel));
  }
  get(itemId: number): Observable<CommissionMatrixModel> {
    return this.apiService.get(CommissionMatrixApiService.ROOT_POINT + '/' + itemId).pipe(map(res => CommissionMatrixModel.fromJson(res) as CommissionMatrixModel));
  }
  update(id: number, data: CommissionMatrixUpdateDto): Observable<any> {
    return this.apiService.patch(CommissionMatrixApiService.ROOT_POINT + '/' + id, data, { excludeFields: [''] });
  }

  search(query = {}, option?: IApiOption): Observable<PaginationAdapter<CommissionMatrixModel>> {
    return this.apiService.get(CommissionMatrixApiService.ROOT_POINT, query, option).pipe(map(data => new PaginationAdapter(CommissionMatrixModel, data)));
  }

  delete(ids: number[], option?: IApiOption): Observable<any> {
    return this.apiService.delete(CommissionMatrixApiService.ROOT_POINT, { ids }, option);
  }

  updateStatus(id: number, status: string): Observable<any> {
    return this.apiService.patch(CommissionMatrixApiService.ROOT_POINT + '/' + id, { status });
  }
}
